import React from "react"

export default () => (
  <svg width="11" height="50">
    <path fill="#D5D5D5" d="M0 50h1l10-25L1 0H0l10 25z" />
  </svg>
)
